/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import {InspectorAdvancedControls , __experimentalColorGradientControl as ColorGradientControl,InspectorControls} from '@wordpress/block-editor';
import {
    SelectControl,
    TextControl
} from '@wordpress/components';

import {
    Fragment,
    useState
} from '@wordpress/element';
/**
* Internal dependencies
*/
import {VayuBlocksHeaderTab,usePanelSettings} from '@vayu-blocks';
import {VayuBlocksAdvancePanel} from '@vayu-blocks/advance-panel';
import ConatinerSettingPanel from './settings/index.js';
import ConatinerStylePanel from './style/index.js';

const panelKeys = [
	'vb-conatiner-set',
	'vb-container-flex',

	'vb-conatiner-overlay',
	'vb-conatiner-background',
	'vb-conatiner-shape',
	'vb-conatiner-slide'
];

const initialPanels = {
	setting: 'vb-conatiner-set',
	style:'',
	advanced: '',
};

const panelOptions = [
	{ label: __( 'Setting', 'vayu-blocks' ), value: 'setting', icon: 'colorwand'},
	{ label: __( 'Style', 'vayu-blocks' ), value: 'style', icon: 'diamond'},
	{ label: __( 'Advanced', 'vayu-blocks' ), value: 'advanced', icon: 'colorpalette'}
];

const InsSettings = ({props, globalcontainerWidth}) => {
	const {
		attributes,
		setAttributes,
		clientId
	} = props;

    const { tab, setTab, openPanels, onTogglePanel  } = usePanelSettings({ clientId, panelKeys, initialPanels, defaultTab: 'setting' });
    const tabComponents = {
		    setting: <ConatinerSettingPanel attributes={attributes} setAttributes={setAttributes} openPanels={openPanels} onTogglePanel={onTogglePanel} globalcontainerWidth={globalcontainerWidth} />,
			style: <ConatinerStylePanel attributes={attributes} setAttributes={setAttributes} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
			advanced: <VayuBlocksAdvancePanel attributes={attributes} setAttributes={setAttributes} video={true}  exclude={['width']} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
	};
	const ANCHOR_REGEX = /[\s#]/g;

	return (
        <Fragment>
        <InspectorControls>
			<div className='th-block-ins'>
        <VayuBlocksHeaderTab 
								value={ tab }
								options={panelOptions}
								onChange={ setTab }
							/>
						
						{tabComponents[tab]}
         </div>
        </InspectorControls>
		<InspectorAdvancedControls>
				    <SelectControl
							label={ __( 'HTML Tag', 'vayu-blocks' ) }
							value={ attributes.containerHTMLTag }
							options={ [
								{ label: __( 'Default (div)', 'vayu-blocks' ), value: 'div' },
								{ label: 'section', value: 'section' },
								{ label: 'header', value: 'header' },
								{ label: 'footer', value: 'footer' },
								{ label: 'article', value: 'article' },
								{ label: 'main', value: 'main' }
							] }
							onChange={ value => setAttributes({ containerHTMLTag: value }) }
						/>
						<TextControl
						label={ __( 'HTML Anchor', 'vayu-blocks' ) }
						help={ __( 'Anchors lets you link directly to a section on a page.', 'vayu-blocks' ) }
						value={ attributes.anchor || '' }
						onChange={ ( value ) => {
							const anchorValue = value.replace( ANCHOR_REGEX, '-' );
							setAttributes( { anchor: anchorValue } );
						} } />
		</InspectorAdvancedControls>
		
        </Fragment>
    );

}
export default InsSettings;